<template>
  <div class="k-onboarding__quest-wrapper">
    <div class="k-onboarding__quest">
      <div class="k-onboarding__name-label">
        <label for="onbording_bdate">Укажите дату рождения:</label>
      </div>
      <div class="k-onboarding__bdate-input-wrapper input-group">
        <input
          class="k-onboarding__input k-onboarding__bdate-input jq-onboarding-input form-control"
          type="tel"
          placeholder="01.01.1970"
          aria-describedby="onboarding3_calendar_addon"
          title="Name"
          id="onbording_bdate"
          v-model="currentBirhday"
          autocomplete="off"
          ref="onboarding_bdate"
          v-mask="'##.##.####'"
          v-focus
        />
          <div class="input-group-append">
            <div
              class="input-group-text k-onboarding__name-input-addon"
              id="onboarding3_calendar_addon"
            >
              <k-calendar
                available-all
                class="k-onboarding__calendar-wrapper"
                :currentSetDate="calendarValue"
                format="Y-m-d"
                @date="(date) => {calendarValue = date}"
              >
              <svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.44444 0V1.8H11.5556V0H13.3333V1.8H14.2222C15.2 1.8 16 2.61 16 3.6V16.2C16 17.19 15.2 18 14.2222 18H1.77778C0.791111 18 0 17.19 0 16.2L0.00888888 3.6C0.00888888 2.61 0.791111 1.8 1.77778 1.8H2.66667V0H4.44444ZM14.2222 6.3H1.77778V16.2H14.2222V6.3Z"
                  fill="#F7981E"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.88954 8.55078V10.3508H10.6673V12.1508H8.88865L8.88954 13.9508H7.11176L7.11087 12.1508H5.33398V10.3508H7.11176V8.55078H8.88954Z"
                  fill="#F7981E"
                />
              </svg>
              </k-calendar>
            </div>
          </div>
      </div>
      <a
        href="#"
        @click.prevent="processSubmit"
        :class="['k-onboarding__quest-next', { active: !!currentBirhday }]"
      >Далее</a>

      <slot/>
    </div>
  </div>
</template>

<script>
import Calendar from "@/components/TheCalendar";
import dateFormat from "../utils/dateformat";
import { mask } from "vue-the-mask";
import { mapActions } from "vuex";

export default {
  name: "OnboardingBirthday",
  props: {
    editProfile: Object,
  },
  components: {
    "k-calendar": Calendar
  },
  directives: {
    mask
  },
  data() {
    return {
      calendarValue: null,
      currentBirhday: null
    };
  },
  computed: {
    currentCreatedProfile() {
      return this.$store.getters.getUserFamily.find(el => el.is_main === "t");
    }
  },
  mounted() {
    if (this.editProfile && this.editProfile.birth_date) {
      this.currentBirhday = dateFormat(
        this.editProfile.birth_date,
        "dd.mm.yyyy"
      );
      this.calendarValue = new Date(this.editProfile.birth_date);
      return;
    }

    if (this.$store.getters.getProfileBirthDate && !this.editProfile) {
      this.currentBirhday = dateFormat(
        this.$store.getters.getProfileBirthDate,
        "dd.mm.yyyy"
      );
      this.calendarValue = new Date(this.$store.getters.getProfileBirthDate);
    }
  },
  watch: {
    calendarValue(date) {
      this.currentBirhday = dateFormat(date, "dd.mm.yyyy");
    }
  },
  methods: {
    ...mapActions(["loadUser", "updateProfile"]),
    async processSubmit() {
      if (this.currentBirhday) {
        if (this.currentCreatedProfile && !this.editProfile) {
          const splitDate = this.currentBirhday.split(".");
          await this.updateProfile({
            birth_date: dateFormat(
              new Date(splitDate[2], splitDate[1] - 1, splitDate[0]),
              "yyyy-mm-dd"
            ),
            id: this.currentCreatedProfile.id
          });
        } else if (this.editProfile) {
          this.editProfile.birth_date = this.currentBirhday;
        } else {
          this.$store.dispatch("setProfileData", {
            birth_date: this.currentBirhday
          });
        }

        this.$router.push({ name: "OnboardingHeight" });
      }
    }
  }
};
</script>

<style scoped>
</style>
